import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const createEvent = async (payload: FormData) => {
	const response = await cmsClient.post<IEvent>(
		"/homepage/admin/events/",
		payload
	);

	return response.data;
};

const useCreateEvent = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Event created successfully" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["events"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(createEvent, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useCreateEvent;
